module.exports = __webpack_public_path__ + "b79d691bc8c06ec81f2ef8776be07f2b.png";